import React from 'react';
import { Helmet } from 'react-helmet';
import { Route, Switch } from 'react-router';
import { DiarizeLoader } from '../helpers/ai/diarize/DiarizeLoader';
import { DiarizeViewer } from '../helpers/ai/diarize/DiarizeViewer';
import { AI_UTILITIES } from '../constants/aiUtilities';
import { useTheme } from '../components/hooks/useTheme';
import './Shared.css';

export const Diarize = () => {
    const { theme } = useTheme();

    const icon = theme === 'light' ? AI_UTILITIES.DIARIZE.lightIcon : AI_UTILITIES.DIARIZE.darkIcon;

    return (
        <div>
            <Helmet>
                <title>{AI_UTILITIES.DIARIZE.name}</title>
            </Helmet>
            <div className="d-flex flex-row align-items-center mb-3">
                <img src={icon} alt="Логотип" className='title-icon mr-3' />
                <h4>{AI_UTILITIES.DIARIZE.name}</h4>
            </div>
            <Switch>
                <Route exact path={AI_UTILITIES.DIARIZE.path} component={DiarizeLoader} />
                <Route path={`${AI_UTILITIES.DIARIZE.path}/:inputIdentifier`} component={DiarizeViewer} />
            </Switch>
        </div>
    );
};

Diarize.displayName = 'Diarize';